<!--<app-header *ngIf="!router.url.includes('/app-ads.txt')"></app-header>-->
<!--<router-outlet></router-outlet>-->
<!--<app-footer #footer *ngIf="!router.url.includes('/app-ads.txt')"></app-footer>-->


<div class="app-layout-grid">

  <!-- Header sits comfortably on top -->
  <app-header *ngIf="!router.url.includes('/app-ads.txt')"></app-header>

  <!-- Main content section holds the background and template pages -->
  <main class="app-main-content">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer stays locked permanently at the bottom edge -->
  <app-footer #footer *ngIf="!router.url.includes('/app-ads.txt')"></app-footer>

</div>
